import { render, staticRenderFns } from "./QuestionsTypeFloatBtns.vue?vue&type=template&id=79fdb5d4&"
import script from "./QuestionsTypeFloatBtns.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypeFloatBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports